import React from 'react'
import BB8AuthPanel from './BB8AuthPanel'
import './BB8TopNav.scss'

// TODO: dynamic class name for active link
const BB8TopNav = ({
  user,
  logout,
  children,
  showAuth = true,
  subHeader
}: {
  user: any
  logout: () => void
  children?: JSX.Element | JSX.Element[]
  showAuth: boolean
  subHeader?: boolean
}) => (
  <header className={`navbar-links-wrapper ${subHeader && 'sub-header'}`}>
    <div className={!subHeader ? 'navbar-links' : 'navbar-sub-links'}>
      <nav>{children}</nav>
      {showAuth && <BB8AuthPanel user={user} logout={logout} />}
    </div>
  </header>
)

BB8TopNav.defaultProps = {
  subHeader: false
}

export default BB8TopNav
